var Handlebars = require("../../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "hide";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<span id=\"doc-mode\" data-view-mode=\"document\" class=\""
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.hideDocMode : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " view-mode iwr\" title=\"Full Document Mode\">\n    <i class=\"icon-docs\"></i>\n</span>\n\n<span id=\"pg-mode\" data-view-mode=\"page\" class=\" "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.hidePgMode : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " iwr view-mode\"\n      title=\"Single Page, Actual-Size Mode\">\n    <i class=\"icon-doc\"></i>\n</span>\n\n<span id=\"pdf-mode\" data-view-mode=\"pdf\" class=\""
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.hidePdfMode : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " iwr view-mode\" title=\"PDF Mode\">\n    <i class=\"icm-file-pdf3\"></i>\n</span>";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/layout/header/headerCenter/modeBtns/modeBtns.hbs
 ** module id = 719
 ** module chunks = 0
 **/